import { render } from "./ticket.vue?vue&type=template&id=c5f6fbc2&scoped=true"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"

import "./ticket.vue?vue&type=style&index=0&id=c5f6fbc2&rel=stylesheet%2Fscss&lang=scss"
import "./ticket.vue?vue&type=style&index=1&id=c5f6fbc2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f6fbc2"]])

export default __exports__